require('./smpl-slides-template.html');
require('./styles.less');
require('./draw-canvas');

var round = function(d, n) {
  var c = Math.pow(10, n);
  return Math.round(d * c) / c;
};

var module = angular.module('bbl.module.view-screenshare');

module.directive('simpleSlides', ['simpleSlides', function(simpleSlides) {
  return {
    templateUrl: 'smpl-slides-template.html',
    restrict: 'EA',
    scope: {
      'user': '=',
      'room': '=',
      'presenter': '=',
    },

    link: function($scope) {
      var room = $scope.room,
      user = $scope.user,
      $apply = setTimeout.bind(null, function() { $scope.$apply(); }, 0);

      $scope.slidesData = {};

      var presentation = simpleSlides(user, room);

      $scope.$watch('presenter', function(p, c) {
        if ($scope.presenter) {
          presentation.setAsPresenter();
        }
      });

      presentation.sub(presentation.types.ONLOAD, function(_, data) {
        $scope.change(0);
        $apply(angular.extend($scope.slidesData, data));
      });

      presentation.sub(presentation.types.ONCHANGESLIDE, function(_, data) {
        $apply($scope.slidesData.current = data);
      });

      presentation.sub(presentation.types.ONDRAWUPDATE, function(_, data) {
        $apply($scope.slidesData.drawPoints = (data || '').split(';').map(function(p) {
          var c = p.split('*');
          return {rx: c[0], ry: c[1]};
        }));
      });

      presentation.sub(presentation.types.CONNECTED, function() {
        $apply($scope.connected = true);
      });

      $scope.change = function(slide) {
        var slidesLen = ($scope.slidesData.slides || []).length;
        presentation.changeSlide(Math.max(0, Math.min(slide, slidesLen)));
      };

      $scope.draw = function(points) {
        presentation.draw(points.map(function(p) {
          return round(p.rx, 6)+'*'+round(p.ry, 6);
        }).join(';'));
      };
    }
  };
}]);




/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/view-screenshare/slideshare/index.js
 ** module id = 399
 ** module chunks = 0
 **/